import React from 'react'
import { Form, TextArea, Button } from 'semantic-ui-react'
import 'semantic-ui-less/semantic.less'

export default class AppraisalForm extends React.Component
{
  state = {
    rawPaste: ''
  }

  handleInputChanged = (event, { name, value }) => {
    this.setState({[name]: value})
  }

  onSubmit = event => {
    // send this.state.rawPaste to our endpoint
    if (this.state.rawPaste.length > 0) {
      this.props.submitFunction(this.state.rawPaste);
    }
  }

  render() {
    return(
      <Form onSubmit={this.onSubmit}>
        <Form.Field
          id='rawPaste'
          name='rawPaste'
          control={TextArea}
          label='Appraisal'
          placeholder='Paste stuff here'
          onChange={this.handleInputChanged}
        />
        <Form.Field
          id='submit'
          control={Button}
          content='Submit'
        />
      </Form>
    )
  }
}
